/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserGroupDto } from '../../models/platform-api-result-of-user-group-dto';

export interface DeleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Params {
  userGroupId: string;
  userAccountId: string;
}

export function deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid(http: HttpClient, rootUrl: string, params: DeleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserGroupDto>> {
  const rb = new RequestBuilder(rootUrl, deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid.PATH, 'delete');
  if (params) {
    rb.path('userGroupId', params.userGroupId, {});
    rb.path('userAccountId', params.userAccountId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserGroupDto>;
    })
  );
}

deleteUsergroupsUsergroupidActionRemoveuseraccountUseraccountid.PATH = '/api/usergroups/{userGroupId}/action/removeuseraccount/{userAccountId}';
